import { Box, Pagination } from "@bca/ui-library";
import React from "react";

interface VehiclesPaginationProps {
  page: number;
  onPageChange: (event: any, page: number) => void;
  totalPages: number;
  isLoading?: boolean;
  totalResultCount?: number;
}

const VehiclesPagination: React.FunctionComponent<VehiclesPaginationProps> = ({
  page,
  onPageChange,
  totalPages,
  isLoading,
  totalResultCount,
}) => {
  if (isLoading || totalResultCount === 0) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignSelf={{
        mobile: "center",
        desktop: "flex-start",
      }}
      alignItems="center"
    >
      <Box
        alignSelf={{
          mobile: "center",
          desktop: "flex-start",
        }}
      >
        <Pagination
          disabled={isLoading}
          count={totalPages}
          page={page}
          defaultPage={1}
          onChange={onPageChange}
        />
      </Box>
    </Box>
  );
};

export default VehiclesPagination;
